<script setup lang="ts">
const props = defineProps({
  selected: {
    type: Number,
  },
  items: {
    type: Array as PropType<number[]>,
  },
});

const emit = defineEmits(["click"]);

function clickEmit(nb: number) {
  emit("click", nb);
}
</script>

<template>
  <div class="toggle_containers body_regular">
    <button
      v-for="(item, index) in props.items"
      :key="index"
      class="toggle_button hover"
      name="0"
      :data-toggled="item === selected"
      @click="clickEmit(item)"
    >
      {{ item }}
    </button>
  </div>
</template>

<style scoped>
.toggle_containers {
  @apply flex flex-row;
  border: solid 1px var(--grey-lightest);
  border-radius: 12px;
  overflow: hidden;
}
.toggle_button {
  @apply flex items-center justify-center px-[12px];
  box-sizing: border-box;
  height: 24px;
  min-width: 38px;
  color: var(--text-secondary-color);

  &[data-toggled="true"] {
    background: var(--grey-light);
    color: var(--text-main-color);
  }

  &:not(:first-child) {
    border-left: solid 1px var(--grey-lightest);
  }
}
.hover:hover {
  background: var(--grey-light);
  color: var(--black-dark);
}
</style>
